import React, { Fragment } from "react";
import externalLink from "../../../assets/images/external-link.png";

function BNumberList(props) {
  let BNumber = data => {
    {
      let action =
        (props.right.web.edit && "edit") ||
        (props.right.web.view && "view");
      let newSearch = "?" + new URLSearchParams({
        action: action,
        _id: data["ID"]
        // hash: `seleted${data.split("-").join("")}`
      }).toString()
      // window.open(`/StylePage${newSearch}`, "_blank")
      window.open(`/BNumber${newSearch}`, "_blank")
    };
  };
  return (
    <Fragment>
      <tr>
        <td className="report-header text-center" width="5%">
          S.NO
        </td>
        <td className="report-header text-center border" nowrap width="10%">
          SUBMISSION DATE
        </td>
        <td className="report-header text-center border" width="5%">
          BNUMBER
        </td>
        <td className="report-header text-center border" width="5%">
          STYLE NO.
        </td>
        <td className="report-header text-center border" width="10%">
          COUNT & CONSTRUCTION
        </td>
        <td className="report-header text-center border" width="5%">
          COMPOSITION
        </td>
        <td className="report-header text-center border" width="5%">
          CUSTOMER-DEPT
        </td>
        <td className="report-header text-center border" width="5%">
          TYPE OF WASH
        </td>
        <td className="report-header text-center border" width="5%">
          FABRIC QUALITY
        </td>
        <td className="report-header text-center border" width="5%">
          TESTING LAB
        </td>
        <td className="report-header text-center border" width="5%">
          TYPE OF TEST
        </td>
        <td className="report-header text-center border" width="5%">
          CLASSIFICATION OF FABRIC
        </td>
        <td className="report-header text-center border" width="5%">
          FINISHED WIDTH
        </td>
        <td className="report-header text-center border" width="5%">
          GSM
        </td>
        <td className="report-header text-center border" width="5%">
          REPORT STATUS
        </td>
        <td className="report-header text-center border" width="5%">
          COMMENTS
        </td>
      </tr>
      {props.list !== undefined &&
        Array.isArray(props.list) &&
        props.list.length > 0 &&
        props.list.map((data, index) => {
          return (
            <Fragment>
              <tr className="text-center">
                <td>{data["S.No."]}</td>
                <td>{data["SUBMISSION DATE"]}</td>
                <td>{data["BNO"]}
                <img
                        title={`Go To Sample Page Of ${data}`}
                        className={"cursor-hover"}
                        style={{
                          cursor: "pointer",
                          marginTop: "-1px",
                          verticalAlign: "top",
                          marginLeft: "5px"
                        }}
                        onClick={() => BNumber(data)}
                        src={externalLink}
                      />
                </td>
                <td>{data["STYLE NO"]}</td>
                <td>{data["COUNT&CONSTRUCTION"]}</td>
                <td>{data["COMPOSITION"]}</td>
                <td className="text-left">{data["CUSTOMER-DEPT"]}</td>
                <td>{data["TYPE OF WASH"]}</td>
                <td>{data["FABRIC QUALITY"]}</td>
                <td>{data["TESTING LAB"]}</td>
                <td>{data["TYPE OF TEST"]}</td>
                <td>{data["CLASSIFICATION OF FABRIC"]}</td>
                <td>{data["FINISHED WIDTH"]}</td>
                <td>{data["GSM"]}</td>
                <td>{data["REPORT STATUS"]}</td>
                <td>{data["COMMENTS"]}</td>
              </tr>
            </Fragment>
          );
        })}
    </Fragment>
  );
}
export default BNumberList;


// WEBPACK FOOTER //
// ./src/components/Report/reports/bNumber.js